function kwaiCall(method, ...args) {
    const kwaiq = window.kwaiq;

    if (kwaiq == null) {
        return;
    }

    // SDK já carregado: a função recebe o comando.
    if (typeof kwaiq === "function") {
        kwaiq(method, ...args);
        return;
    }

    // Bootstrap adiado: kwaiq ainda é a fila (array). Chamar como função lança TypeError
    // e interrompe o redirecionamento da página do PIX.
    if (typeof kwaiq[method] === "function") {
        kwaiq[method](...args);
        return;
    }

    if (Array.isArray(kwaiq)) {
        kwaiq.push([method, ...args]);
    }
}

export function initKwaiPixel({ pixelId, data = null, options = null }) {
    if (window.kwaiq == null) {
        return;
    }

    if (typeof window.kwaiq.load === "function") {
        window.kwaiq.load(pixelId);
    }

    kwaiCall("init", pixelId, data, options);
}

export function dispatchKwaiContentViewEvent({ data = null, options = null }) {
    kwaiCall("track", "contentView", data, options);
}

export function dispatchKwaiInitiateCheckoutEvent({
    data = null,
    options = null,
}) {
    kwaiCall("track", "initiateCheckout", data, options);
}

export function dispatchKwaiAddPaymentInfoEvent({
    data = null,
    options = null,
}) {
    kwaiCall("track", "addPaymentInfo", data, options);
}

export function dispatchKwaiPurchaseEvent({
    data = null,
    options = null,
}) {
    kwaiCall("track", "purchase", data, options);
}
